// Login actions
import initiateLogin from './action/initiateLogin'
import login from './action/login'

// Registration actions
import initiateJoin from './action/initiateJoin'
import verifyCode from './action/verifyCode'
import join from './action/join'

// Get query parameters
import setQuery from './action/set-query'

// Upgrade actions
import upgrade from './action/upgrade'
import verifyUpgrade from './action/verifyUpgrade'

import invite from './action/invite'
import verifyInvite from './action/verifyInvite'

// Reset password actions
import reset from './action/reset'
import resetPassword from './action/resetPassword'

import verifyReset from './action/verifyReset'

// Verify an access token
import verify from './action/verify'
import verifyToken from './action/verifyToken'

// Verify an email address from a verification email link
import verifyEmail from './action/verifyEmail'

// Logout and invalidate the access token
import logout from './action/logout'

// Change email action
import changeEmail from './action/changeEmail'

// Change password action
import changePassword from './action/changePassword'

// Change phone action
import changePhone from './action/changePhone'

// Add phone number action
import addPhone from './action/addPhone'

import submitMfa from './action/submitMfa'

export default {
    initiateLogin,
    login,
    initiateJoin,
    verifyCode,
    join,
    setQuery,
    upgrade,
    verifyUpgrade,
    invite,
    verifyInvite,
    reset,
    resetPassword,
    verifyReset,
    verify,
    verifyEmail,
    verifyToken,
    logout,
    changeEmail,
    changePassword,
    changePhone,
    addPhone,
    submitMfa
}
